export default "__VITE_ASSET__eQgOwrZl__"